import React from 'react'
import { Skeleton } from '@mui/material'
import BodyHeader from '../molecules/BodyHeader'
import Figures from '../molecules/Figures'
import ImageList from '../molecules/ImageList'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import useProjects from '../../hooks/useProjects'
import useFigures from '../../hooks/useFigures'
import useDefault from '../../hooks/useDefault'

import { APP_BASE_URL, CATEGORIES, PROJECTS_URL, SERVICES } from '../../constants'
import { useNavigate, useParams } from 'react-router-dom'

const Projects = () => {
	const navigate = useNavigate()

	const handlePageChanged = (event, value) => {
		navigate(`${APP_BASE_URL}${PROJECTS_URL}/${value}`)
	}

	const { isLoading, title, content } = useProjects()
	let { pageNumber } = useParams()

	pageNumber = pageNumber || 1

	const projects_per_page = 8
	const { figures } = useFigures(CATEGORIES.FIGURES.PROJET.id)
	const { data: projets } = useDefault(SERVICES.PROJECT, pageNumber, projects_per_page)

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}

			{projets?.list && (
				<Zone
					sx={{
						borderRadius: 0,
						textAlign: 'center',
						p: (theme) => theme.spacing(20, 14, 10, 14),
						bgcolor: 'text.white',
					}}
				>
					<ImageList
						list={projets?.list}
						needPagination
						handlePageChanged={handlePageChanged}
						pageNumber={parseInt(pageNumber)}
						totalPages={parseInt(projets?.infos?.totalPages)}
					/>
				</Zone>
			)}
			<Zone color="black">
				<TitleSubtitle
					subtitle="Les projets en quelques chiffres"
					title="depuis 2012"
					color="white"
					titleColor="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Zone>
		</>
	)
}

export default Projects
